import {CountryDialCodeIdEnum} from "@/core/constants/enums/countryDialCodeIdEnum";

const data = () => ({
    countryCodes: []
});

async function fetchCountryCodes() {
    const [err, response] = await to(
        api.countryCode.getAll()
    );

    if (err) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.countryCodes = response.data;

    const currentCode = process.env.MIX_APP_PHONE_DIAL_CODE;
    const currentCountryCodeObjects = this.countryCodes.find(code => code.dialCode === `+${currentCode}`);
    return _.get(currentCountryCodeObjects, 'id', CountryDialCodeIdEnum.GERMANY);
}

export default {
    data,
    methods: {
        fetchCountryCodes,
    }
}